import React from 'react'
import { Box, Flex, SkeletonBox } from '@moonpig/launchpad-components'
import { styled } from '@moonpig/launchpad-utils'
import { ComboboxGroup } from '@ariakit/react'
import { SKELETON_LIST_ITEM_HEIGHT_PX, MAX_SUGGESTIONS } from '../constants'

const TEXT_SKELETON_WIDTHS = ['60%', '80%']

const StyledIconSkeletonBox = styled(SkeletonBox)`
  border-radius: 50%;
`

const StyledSkeletonBox = styled(SkeletonBox)`
  border-radius: 8px;
`

export const SkeletonList = () => {
  return (
    <ComboboxGroup data-testid="lp-nav-search-suggestions-skeleton">
      <Box pb={6}>
        {Array.from({ length: MAX_SUGGESTIONS }).map((_, index) => (
          <Flex
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            my={6}
            px={5}
          >
            <StyledIconSkeletonBox
              width={SKELETON_LIST_ITEM_HEIGHT_PX}
              height={SKELETON_LIST_ITEM_HEIGHT_PX}
              mr={4}
            />
            <StyledSkeletonBox
              width={`calc(${
                TEXT_SKELETON_WIDTHS[index % TEXT_SKELETON_WIDTHS.length]
              } - ${SKELETON_LIST_ITEM_HEIGHT_PX})`}
              height={SKELETON_LIST_ITEM_HEIGHT_PX}
            />
          </Flex>
        ))}
      </Box>
    </ComboboxGroup>
  )
}
